import { render, staticRenderFns } from "./TestProcessServerTable.vue?vue&type=template&id=89caea72"
import script from "./TestProcessServerTable.vue?vue&type=script&lang=js"
export * from "./TestProcessServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports